<template>
  <div
    class="inputo p-1 text-c14"
    :class="{'error': error, 'success': success, 'deseable': deseable}"
    :style="{'height': height, 'border': border, 'border-radius': radius, 'background-color': background}"
  >
    <div class="flex h-full items-center">
      <input
        v-model="value"
        :type="typePassword"
        class="w-full h-full pl-3 pr-3"
        :placeholder="placeholder"
        :style="{'font-size': size, 'font-weight': weight}"
        @input="emitValue"
      >
      <icon
        :data="icons.ic_eye"
        height="25"
        width="25"
        class="mr-2 cursor-pointer"
        original
        @click="togglePassword"
      />
    </div>
  </div>
</template>

<script>
import ic_eye from '../../../assets/icons/eyeBlue.svg'
import ic_lock from '../../../assets/icons/lock.svg'

export default {
  name: 'PasswordInput',
  props: {
    deseable: Boolean,
    placeholder: { type: String, default: '' },
    valueT: { type: String, default: '' },
    size: { type: String, default: '14px' },
    weight: { type: String, default: '400' },
    height: { type: String, default: '40px' },
    border: { type: String, default: '1px solid rgba(93, 56, 224, 0.3)' },
    radius: { type: String, default: '4px' },
    background: { type: String, default: 'white' }
  },
  data() {
    return {
      value: '',
      typePassword: 'password',
      error: false,
      success: false,
      icons: { ic_eye, ic_lock }
    }
  },
  created() {
    this.value = this.valueT
  },
  methods: {
    togglePassword() {
      this.typePassword = this.typePassword === 'password' ? 'text' : 'password'
    },
    emitValue() {
      this.$emit('info', this.value)

      // Validation interne pour visuel uniquement
      const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&+]).{8,}$/
      if (this.value.length > 0) {
        if (regex.test(this.value)) {
          this.success = true
          this.error = false
        } else {
          this.error = true
          this.success = false
        }
      } else {
        this.error = false
        this.success = false
      }
    }
  }
}
</script>


<style lang="scss" scoped>
@import "../../../assets/styles/sass/variables.scss";
.inputo{
  border: 1px solid #E8E8E8;
  box-sizing: border-box;
  font-family: $font-default;
}
input{
  color: #0e0e0e;
  background-color: transparent;
  border-radius: 20px;
}
.inputo:focus-within {
  border: 1px solid $hover-color!important;
}
.inputo:hover {
  border: 1px solid $hover-color!important;
}
.error{
  border: 1px solid #ea9f9f!important;
}
.success{
  border: 1px solid rgb(92, 224, 56) !important;
}
.lab{
  background: #F2F2F2;
  border-radius: 10px;
  height: 35px;
  font-size: 14px;
  line-height: 27px;
}
.deseable{
  background: #eeeeee;
}

@media screen and (max-width: 769px) and (min-width: 701px){
  .inputo{
    height: 65px;
  }
  input{
    font-size: 18px;
  }
}

@media screen and (max-width: 700px){
  .inputo {
    height: 55px;
  }
  input{
    font-size: 14px;
  }
}
</style>
